import React from 'react';
import {
  Table,
  Card,
  CardBody,
  Badge,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
} from 'reactstrap';
import {Maybe} from 'monet';
import {useTranslation} from 'react-i18next';

import {buildSelectOptions} from '@/components/Form/formHelper';
import {mapWithIndex, blank, numberFormat} from '@/util';
import Icon from '@/views/shared/Icon';
import AmoebaLink from '@/components/AmoebaLink';

const payoutList = mapWithIndex((payout, idx) => (
  <tr key={`revenue_payout_${idx}`} className={payout.trColor}>
    <td>
      <Badge
        color={payout.numColor}
        style={{
          paddingRight: '9px',
          paddingLeft: '9px',
          borderRadius: '9px',
        }}
      >
        {payout.num}
      </Badge>
    </td>
    <td>
      {Maybe.fromFalsy(payout.showArrowIcon)
        .map(() => (
          <Icon icon='arrow-right' style={{margin: '0 10px 0 20px'}} />
        ))
        .orNull()}
      <AmoebaLink href={`/producers/${payout.producerId}`}>
        {payout.producerName}
      </AmoebaLink>
    </td>
    <td className='text-center'>{payout.dueDate}</td>
    <td className='text-center'>{payout.installmentNo}</td>
    <td className='text-right'>
      {Maybe.fromFalsy(payout.payOutAmount > 0)
        .map(() => numberFormat.toDollar(payout.payOutAmount))
        .orNull()}
    </td>
  </tr>
));

const paginationList = (page, totalSize, handlePaginationClick) => (
  <>
    <div style={{float: 'left'}}>
      Displaying {page + 1} - {page + 1} of {totalSize} record(s)
    </div>
    <Pagination style={{float: 'right'}}>
      <PaginationItem disabled={page === 0}>
        <PaginationLink onClick={() => handlePaginationClick(page - 1)}>
          Previous
        </PaginationLink>
      </PaginationItem>
      {mapWithIndex(
        (p, idx) => (
          <PaginationItem
            key={`page_${idx}`}
            active={page === idx}
            disabled={totalSize === 1}
          >
            <PaginationLink onClick={() => handlePaginationClick(idx)}>
              {idx + 1}
            </PaginationLink>
          </PaginationItem>
        ),
        Array(totalSize)
      )}
      <PaginationItem disabled={page === totalSize - 1 || totalSize < 2}>
        <PaginationLink onClick={() => handlePaginationClick(page + 1)}>
          Next
        </PaginationLink>
      </PaginationItem>
    </Pagination>
  </>
);

const Particular = ({result, totalSize, currentData, setData}) => {
  const {currentPayMode, page} = currentData;
  const {t: tr} = useTranslation();

  if (blank(result)) {
    return null;
  }

  const handlePayModeClick = e => {
    setData({
      ...currentData,
      currentPayMode: e.target.value,
      page: 0,
    });
  };

  const handlePaginationClick = selectedPage => {
    setData({
      ...currentData,
      page: selectedPage,
    });
  };

  return (
    <>
      <Card>
        <CardBody>
          <Row form>
            <Col md={1}>View By</Col>
            <Col md={3}>
              <select
                name='payMode'
                className='custom-select'
                defaultValue={currentPayMode}
                onChange={handlePayModeClick}
              >
                {buildSelectOptions(
                  tr('selection:commission_type'),
                  currentPayMode
                )}
              </select>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <br />
      <Card>
        <CardBody>
          {paginationList(page, totalSize, handlePaginationClick)}
          <br />
          <Table>
            <thead>
              <tr>
                <th style={{width: '5%'}} />
                <th style={{width: '40%'}}>Payee</th>
                <th className='text-center' style={{width: '20%'}}>
                  Due Date
                </th>
                <th className='text-center' style={{width: '10%'}}>
                  Installment No.
                </th>
                <th className='text-right' style={{width: '15%'}}>
                  Pay-out Amount
                </th>
              </tr>
            </thead>
            <tbody>{payoutList(result.payoutRecords)}</tbody>
          </Table>
          {paginationList(page, totalSize, handlePaginationClick)}
        </CardBody>
      </Card>
    </>
  );
};

export default Particular;
